import React, {useState, useEffect} from "react";
import axios from "axios";
import { BaseUrl } from "../../Actions/Base";
import { useDispatch, useSelector } from "react-redux";
import { GetInstituteDataAndSendOtp } from "../../Actions/UserA";

const InstituteOtpVerificationPopup = ({setOpenSignupScreen, InstituteData, instituteId }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const [otp, setOtp] = useState(new Array(4).fill("")); // Array for OTP inputs
  const [error, setError] = useState(""); // Error message

  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [resendMessage, setResendMessage] = useState("");


  const Dispatch = useDispatch();

//   const resendOtp = () => {
//     if (instituteId) {
//         Dispatch(GetInstituteDataAndSendOtp(instituteId));
//     }
// };

const resendOtp = () => {
  if (instituteId && !resendDisabled) {
    // Dispatch(GetInstituteDataAndSendOtp(instituteId));

    Dispatch(GetInstituteDataAndSendOtp(instituteId, 
      () => {
         // Show success message
        setResendMessage("OTP sent successfully.");
        
        // Disable resend and start timer
        setResendDisabled(true);
        setResendTimer(60); // 60 seconds
      },
      (errorMessage) => {
        console.log("errorMessage",errorMessage);
    }
      ))

    const timerInterval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          setResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }
};


  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); // Only allow numbers
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input field if digit entered
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

    useEffect(() => {
      if (resendMessage) {
        const timer = setTimeout(() => setResendMessage(""), 10000);
        return () => clearTimeout(timer);
      }
    }, [resendMessage]);
  
    const axiosInstance = axios.create({
      baseURL: BaseUrl,
      withCredentials: true,
    });

    const handleSubmit = async () => {
      const fullOtp = otp.join(""); // Combine array to string
      console.log("Submit", fullOtp);
  
      if (fullOtp.length < 4) {
        setError("Please enter a valid 4-digit OTP.");
        return;
      }
  
      const payload = {
        instituteId: instituteId,
        OTP: fullOtp,
      };
  
      try {
        const res = await axiosInstance.post("/api/verify-institute-otp", payload);
        console.log(res);
  
        if (res?.data?.success === true) {
            setOpenSignupScreen("PasswordScreen")
        } else if (res?.data?.success === false) {
          setError(res?.data?.message);
        }
      } catch (err) {
        console.log(err);
        setError(err?.response?.data?.message || "An error occurred.");
      }
    };

    const maskEmail = (email) => {
      if (!email || !email.includes("@")) return "";
    
      const [localPart, domain] = email.split("@");
      const visible = localPart.slice(0, 3);
      const masked = "*".repeat(Math.max(localPart.length - 3, 0));
    
      return `${visible}${masked}@${domain}`;
    };
    
    const maskPhone = (phone) => {
      if (!phone) return "";
      
      const last3 = phone.slice(-3);
      const masked = "*".repeat(Math.max(phone.length - 3, 0));
    
      return `${masked}${last3}`;
    };
    

    return (
        <div className="w-[360px]">
          <h2
            className=" mb-[10px] text-center text-[22px]"
          >
            OTP Verification
          </h2>
          <p className="text-center text-[18px] w-[350px]">An OTP has been sent to the registered email address <span className="font-bold">{maskEmail(InstituteData.email)}</span> and phone number <span className="font-bold">{maskPhone(InstituteData.phone)}</span> </p>
          <div className="w-full flex justify-center items-center gap-[10px] mt-[20px]">
              {otp.map((value, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength={1}
                  value={value}
                  onChange={(e) => handleChange(e.target, index)}
                  className={`w-[47px] h-[54px] rounded-md py-2 px-[10px] ${Border} text-bold shadow-[4px_5px_6px_#00000029] text-center`}
                />
              ))}
          </div>
          <p className="w-full text-[16px] text-center my-[15px]">Did not receive OTP?{" "} 
            {/* <span className="text-[#A1A3EF] cursor-pointer" onClick={resendOtp}> */}
            {resendDisabled ? (
              <span className="text-[#A1A3EF]"> Resend in {resendTimer}s</span>
            ) : (
              <span className="text-[#A1A3EF] cursor-pointer" onClick={resendOtp}>
                 Resend
              </span>
            )}
          </p>
          {error && (
          <p className="text-[#ff0000] text-center mt-2 text-[14px]">{error}</p>
        )}
        {resendMessage && (
          <p className="text-[#008000] text-center text-[14px]">{resendMessage}</p>
        )}

          <div className="w-full flex justify-center items-center gap-[15px] mt-[25px]">
            <button
                className="py-[7px] w-[120px] rounded-[6px] text-[#A1A3EF] text-[14px] cursor-pointer"
                style={{border:"2px solid #A1A3EF"}}
                onClick={() => {
                    const isLocalhost = window.location.hostname === "localhost";
                    window.location.href = isLocalhost
                    ? "http://localhost:3000"
                    : "https://vehiclelearning.com/"; // Replace with your live site URL
                }}
              >
               Back To Home
            </button>
            <button
                className="w-[100px] py-[7px] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleSubmit}
                // onClick={() => {
                //             setOpenSignupScreen("PasswordScreen")
                //             }} 
                style={{border:"2px solid #A1A3EF"}}>
               Verify
            </button>
          </div>
        </div>
    );
  };

export default InstituteOtpVerificationPopup;
